module.exports = __webpack_public_path__ + "img/mmmint.ai.872fa1d7.png";